export default {
    white: '#FFFFFF',
    lighter: '#F5F5F5',
    light: '#DDDDDD',
    grey: '#EBEBEB',
    grey_light: '#f9f9f9',
    regular: '#999999',
    dark: '#666666',
    darker: '#333333',
    black: '#000000',

    primary: '#0A26B1',
    secondary: '#341AE8',
    blue_button: '#4363FF',

    success: '#52CC6F',
    info: '#17a2b8',
    warning: '#FFC107',
    danger: '#dc3545',

    transparent: 'transparent',
    darkTransparent: 'rgba(0, 0, 0, 0.5)',
    darkerTransparent: 'rgba(0, 0, 0, 0.6)',
    whiteTransparent: 'rgba(255, 255, 255, 0.3)',

    border: '#DDDDDD',
    lightYellow: '#FFF3E6',
    lightBlue: '#E2ECFF',
    lightBlueDark: '#D1E0FD',
    facebookColor: '#3b5998'
};
